import {
  Button,
  DialogActions,
  DialogContent,
  Grid,
  MenuItem,
  Paper,
  Typography,
  Radio,
} from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { notifUtils } from "../../../components/NotifUtils/NotifUtils";

import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import InputImage from "../../../components/InputImage";
import appStore from "../../../Store/AppStore";
import categoryStore from "../../../Store/CategoryStore";
import productStore from "../../../Store/ProductStore";
import ProductService from "../../../Services/ProductService/ProductService";
import TenantService from "../../../Services/TenantService/TenantService";
import tenantStore from "../../../Store/TenantStore";

import promotionStore from "../../../Store/PromotionStore";
import EditorialService from "../../../Services/EditorialService/EditorialService";
import PropertyService from "../../../Services/PropertyService/index";
import propertyStore from "../../../Store/PropertyStore";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import InputTextareaEditor from "../../../components/InputTextareaEditor";
import { useState } from "react";
import { useEffect } from "react";

const styles = (theme) => ({
  header: {
    textAlign: "left",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
  dateMall: {
    margin: "23px 0",
  },
});

function Form(props) {
  const { classes, width, data, cancel } = props;
  const [openDialog, setOpenDialog] = React.useState(true);
  const [appState, appActions] = appStore();
  const [, productActions] = productStore();
  const [, promotionActions] = promotionStore();
  const [categoryProductState, categoryProductActions] = categoryStore();
  const [tenantState, tenantActions] = tenantStore();
  const [isHighLight, setisHighLight] = useState(false);
  const [buttonAddProduct, setbuttonAddProduct] = useState(true);

  const [state, setState] = React.useState({
    formData: {
      id: "",
      title: "",
      subTitle: "",
      description: "",
      image_banner: "",
      image_urls: [],
      type: "",
      link_url: "",
    },
  });
  const [componentWillMount] = React.useState(false);
  console.log(isHighLight);
  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
    ],
  };

  const formats = ["bold", "italic", "underline", "list", "bullet", "link"];

  const user = JSON.parse(localStorage.getItem("user"));
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());

  const onRemoveImage = (value) => {
    console.log(value);
    const { formData } = state;
    let index = formData["image_urls"].indexOf(value);
    console.log(index);
    console.log(state.formData.image_urls);
    if (index > -1) {
      console.log("masuk sini");
      formData["image_urls"] = [];
    }
    console.log(state.formData.image_urls);
    setState({ formData });
  };

  const handleCloseDialog = () => {
    setState({
      formData: {
        id: "",
        title: "",
        description: "",
        image_banner: "",
        image_urls: [],
        type: "",
        link_url: "",
      },
    });
    setOpenDialog(false);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  const handleDueDateChange = (date) => {
    setEndDate(date);
  };

  const handleChange = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    setState({ formData });
  };
  // console.log(state.formData);
  const handleSubmit = (event) => {
    confirm("Submit", "Are you sure to Submit ?").then(async (onProcess) => {
      if (props.data === null) {
        const { formData } = state;
        console.log(formData);

        formData["image_urls"] = formData["image_urls"].filter(
          (imageObj) => imageObj !== ""
        );
        formData["startTime"] = startDate;
        formData["endTime"] = endDate;
        // console.log(formData);
        // console.log("???????");
        const newData = selectedOption.map((e) => {
          let obj = {
            id: e.value,
          };
          return obj;
        });
        // console.log(newData);
        const obj = {
          title: formData.title,
          sub_title: formData.subTitle,
          description: formData.description,
          is_primary: false,
          start_time: formData.startTime,
          end_time: formData.endTime,
          approved: true,
          with_product: true,
          link_url: formData.link_url,
          type: {
            id: +formData.tenant_type,
          },
          // create_time: "2023-01-03T12:00:00Z",

          product: newData,
          image_urls: formData.image_urls,
        };
        console.log(obj);
        await EditorialService.storeData(obj);
        notifUtils("Successfully Created Editorial", "success");
        handleCloseDialog();
        cancel();
      } else {
        const { formData } = state;
        formData["image_urls"] = formData["image_urls"].filter(
          (imageObj) => imageObj !== ""
        );
        formData["startTime"] = startDate;
        formData["endTime"] = endDate;
        const newData = selectedOption.map((e) => {
          let obj = {
            id: e.value,
          };
          return obj;
        });
        // console.log(newData);
        const obj = {
          title: formData.title,
          sub_title: formData.subTitle,
          description: formData.description,
          is_primary: false,
          start_time: formData.startTime,
          end_time: formData.endTime,
          approved: true,
          with_product: true,
          link_url: formData.link_url,
          type: {
            id: formData.tenant_type,
          },
          is_landing: isHighLight,
          // create_time: "2023-01-03T12:00:00Z",
          product: newData,
          image_urls: formData.image_urls,
        };
        console.log(obj);
        // console.log();
        await EditorialService.putData(obj, formData.id);
        notifUtils("Successfully Update Editorial", "success");

        handleCloseDialog();
        cancel();
      }
    });
  };
  // console.log(state.formData);
  // get value add and edit form
  // console.log(props.data);
  const [isHighlightTrigger, setisHighlightTrigger] = useState(false);
  // setState
  React.useEffect(() => {
    if (data) {
      data.image_urls.push("");
      setState({
        formData: {
          id: data.id,
          title: data.title,
          tenant_type: String(data.type.id),
          subTitle: data.sub_title,
          description: data.description,
          image_banner: data.image_urls[0],
          image_urls: data.image_urls ? data.image_urls : [],
          type: "property",
          link_url: data.link_url,
        },
      });
      appActions.setImageUrls([data.image_urls]);
      let newRes = [];
      if (data.product) {
        data.product.map((item) => {
          let obj = { value: item.id, label: item.name, logo: item.main_image };
          newRes.push(obj);
        });
      }
      // console.log(data);
      setisHighLight(data.is_landing);
      setSelectedOption(newRes);
      setStartDate(data.start_time);
      setEndDate(data.end_time);
      setisHighlightTrigger(true);
    }
  }, [componentWillMount, setStartDate, setEndDate, setState, data]);
  // console.log(data?.product);
  // console.log("<<<<>>>>");
  // const options = [
  //   { value: "option1", label: "Option 1" },
  //   { value: "option2", label: "Option 2" },
  //   { value: "option3", label: "Option 3" },
  // ];

  // SEARCH BRAND
  const [optionBrand, setoptionBrand] = useState([]);
  const [selectedBrand, setselectedBrand] = useState({
    id: "",
    name: "Choose Brand",
  });
  const [insearchBrand, setinsearchBrand] = useState("");
  const [openSelectBrand, setopenSelectBrand] = useState(false);
  const getBrand = async (id) => {
    const res = await TenantService.getData({
      num: 1000,
      property: id,
      cursor: "",
    });
    let newRes = [];
    res.data.map((item) => {
      let obj = { value: item.id, label: item.name, logo: item.logo.square };
      newRes.push(obj);
    });
    // console.log(newRes);
    setoptionBrand(newRes);
  };
  // console.log(optionBrand);

  // useEffect(() => {
  //   getBrand();
  // }, []);
  const handleChangeSelectBrand = (value) => {
    // console.log(value);
    setselectedBrand({
      id: value.value,
      name: value.label,
      // logo: value.logo.square,
    });
  };
  // console.log(selectedBrand);

  const loadoptionBrand = async (e) => {
    setinsearchBrand(e.target.value);
    // console.log(e.target.value);
    const res = await TenantService.getData({
      num: 1000,
      property: selectProperty.id,
      cursor: "",
      keyword: e.target.value,
    });
    // console.log(res.data);
    let newRes = [];
    res.data.map((item) => {
      let obj = { value: item.id, label: item.name, logo: item.logo.square };
      newRes.push(obj);
    });
    // console.log(newRes);
    setoptionBrand(newRes);
  };
  // END SEARCH BRAND

  // SEARCH PRODUCT
  const [optionProduct, setoptionProduct] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [insearch, setinsearch] = useState("");
  const [openSelect, setopenSelect] = useState(false);
  const getProduct = async (id) => {
    const res = await ProductService.getData({
      tenant_id: id,
      property_id: 0,
      page: 1,
      perPage: 1000,
    });
    let newRes = [];
    res.data.map((item) => {
      let obj = { value: item.id, label: item.name, logo: item.main_image };
      newRes.push(obj);
    });
    // console.log(newRes);
    setoptionProduct(newRes);
  };
  // console.log(optionProduct);
  // useEffect(() => {
  //   getProduct();
  // }, []);
  const handleChangeSelect = (value) => {
    console.log(value);
    const cek = selectedOption.includes(value);
    console.log(cek);
    if (!cek) {
      setbuttonAddProduct(true);
      setSelectedOption([...selectedOption, value]);
    }
    // setselectProperty([]);
    // setselectedBrand([]);
    // setselectTenant([]);
  };

  // console.log(selectedOption);
  // console.log(optionBrand);
  // console.log("+======");
  const loadoption = async (e) => {
    setinsearch(e.target.value);
    // console.log(e.target.value);
    const res = await ProductService.getData({
      tenant_id: +selectedBrand.id,
      property_id: 0,
      page: 1,
      perPage: 100,
      keyword: e.target.value,
    });
    // console.log(res.data);
    let newRes = [];
    res.data.map((item) => {
      let obj = { value: item.id, label: item.name, logo: item.main_image };
      newRes.push(obj);
    });
    // console.log(newRes);
    setoptionProduct(newRes);
  };
  // END SEARCH PRODUCT

  //START SELECT PROPERTY
  const [propertyState, propertyActions] = propertyStore();
  let perPage = 10;
  const [selectProperty, setselectProperty] = useState({
    id: "",
    name: "Choose Mall",
  });
  const [openoptionProperty, setopenoptionProperty] = useState(false);
  const [insearchProperty, setinsearchProperty] = useState("");

  const loadoptionProperty = (e) => {
    const refresh = true;
    const propertyType = "";
    setinsearchProperty(e.target.value);
    var query = {
      num: perPage.toString(),
      operational_level: user?.operational?.level,
      level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
      type: propertyType || "",
      parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
      cursor: refresh ? "" : propertyState.header["x-cursor"] || "",
      keyword: e.target.value,
    };
    propertyActions.getList(query, refresh);
  };
  const loadoptionProperty2 = (e) => {
    const refresh = true;
    const propertyType = "";
    var query = {
      num: perPage.toString(),
      operational_level: user?.operational?.level,
      level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
      type: propertyType || "",
      parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
      cursor: refresh ? "" : propertyState.header["x-cursor"] || "",
    };
    propertyActions.getList(query, refresh);
  };
  useEffect(() => {
    loadoptionProperty2();
  }, []);
  // console.log(selectProperty);
  // END SELECT PROPERTY

  //START SELECT TENANT
  const [dataTenant, setdataTenant] = useState([]);
  const [selectTenant, setselectTenant] = useState({
    id: "",
    name: "Choose Tenant",
  });

  const handleGetTenantList = async (id) => {
    var query = {
      num: 1000,
      property: id,
      cursor: "",
    };

    const res = await TenantService.getData(query);
    // console.log(res);
    setdataTenant(res);
    // console.log("++++");
  };
  // END SELECT TENANT
  const [errorHighlight, seterrorHighlight] = useState("limit highlight");
  const handleChangeHighlight = async (e) => {
    // console.log(e.target.value);
    // console.log(data.id);
    try {
      const res = await EditorialService.cekHighlight();
      if (isHighLight === false) {
        setisHighLight(true);
      }
      if (isHighLight === true) {
        setisHighLight(false);
      }
    } catch (error) {
      console.log("masuk sini");
      if (isHighLight === true) {
        setisHighLight(false);
      }
    }
  };
  return (
    <CustomizedDialogs
      disableBackdropClick
      maxWidth={width !== "xs" ? "md" : false}
      fullScreen={width === "xs"}
      title={props.title}
      open={openDialog}
      handleClose={handleCloseDialog}
    >
      <DialogContent classes={{ root: classes.content }} dividers>
        <ValidatorForm
          id="myform"
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <Paper className={classes.root} style={{ boxShadow: "none" }}>
            <Grid container>
              <Typography
                variant="subtitle1"
                className={classes.header}
                gutterBottom
              >
                Input Data Editorial
              </Typography>
              <Grid item xs={12}>
                <TextValidator
                  id="title"
                  label="Add Title"
                  name="title"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  value={state.formData.title}
                  type="text"
                  inputProps={{ maxLength: 61 }}
                  validators={["required", "maxStringLength:60"]}
                  errorMessages={[
                    "Title is required",
                    "maximum character is 60",
                  ]}
                  onChange={handleChange}
                  autoFocus
                />
                <TextValidator
                  id="subTitle"
                  label="Add Sub Title"
                  name="subTitle"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  value={state.formData.subTitle}
                  type="text"
                  inputProps={{ maxLength: 61 }}
                  validators={["required", "maxStringLength:60"]}
                  errorMessages={[
                    "Title is required",
                    "maximum character is 60",
                  ]}
                  onChange={handleChange}
                  autoFocus
                />
                <label className="mt-3">Editorial Type</label>
                <div>
                  <Radio
                    checked={state.formData.tenant_type === "1"}
                    onChange={handleChange}
                    value="1"
                    name="tenant_type"
                    inputProps={{ "aria-label": "1" }}
                  />
                  <label>Shop</label>
                  <Radio
                    checked={state.formData.tenant_type === "2"}
                    onChange={handleChange}
                    value="2"
                    name="tenant_type"
                    inputProps={{ "aria-label": "1" }}
                  />
                  <label>Dine</label>
                </div>
                <label className="mt-3">Select Product</label>
                {selectedOption &&
                  selectedOption.map((e, index2) => {
                    return (
                      <div
                        class="alert alert-info d-flex justify-content-between align-items-center"
                        role="alert"
                      >
                        <img
                          src={e.logo}
                          style={{
                            width: "2rem",
                            height: "2rem",
                            marginRight: "1rem",
                          }}
                          alt=""
                        />
                        <div>{e.label}</div>
                        <div
                          onClick={() => {
                            // console.log(e.value);
                            const newselected = selectedOption.filter(
                              (item, index) => {
                                // console.log(item.value);
                                if (index2 !== index) {
                                  return item;
                                }
                              }
                            );
                            setSelectedOption(newselected);
                            // console.log(newselected);
                            // console.log(",<<<<<,");
                          }}
                        >
                          <div className="cursor-pointer">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              class="bi bi-trash3"
                              viewBox="0 0 16 16"
                            >
                              <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {buttonAddProduct ? (
                  <>
                    <button
                      type="button"
                      onClick={() => {
                        setbuttonAddProduct(false);
                      }}
                      class="btn btn-primary btn-lg btn-block"
                    >
                      Add Product
                    </button>
                  </>
                ) : (
                  <>
                    {/* DROPDOWN PROPERTY */}
                    <div class="dropdown">
                      <TextValidator
                        // id="search"
                        label="Search property..."
                        name="search"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className={classes.textField}
                        // margin="normal"
                        variant="outlined"
                        value={insearchProperty}
                        type="text"
                        inputProps={{ maxLength: 61 }}
                        // validators={["required", "maxStringLength:60"]}
                        // errorMessages={[
                        //   "Title is required",
                        //   "maximum character is 60",
                        // ]}
                        onChange={loadoptionProperty}
                        autoComplete="off"
                        // autoFocus
                      />

                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        {propertyState.data.map((e) => {
                          // console.log(e);
                          return (
                            <>
                              <div
                                onClick={() => {
                                  setselectProperty({ id: e.id, name: e.name });
                                  handleGetTenantList(e.id);
                                  getBrand(e.id);
                                  setinsearchProperty(e.name);
                                  setinsearchBrand("");
                                  setinsearch("");
                                }}
                                class="dropdown-item"
                              >
                                {e.name}
                              </div>
                            </>
                          );
                        })}
                      </div>
                      {/* </> */}
                      {/* ) : null} */}
                    </div>
                    {/* END DROPDOWN PROPERTY */}

                    {/* SEARCH BRAND */}
                    {optionBrand && optionBrand.length > 0 ? (
                      <>
                        {/* <div className="position-relative"> */}
                        <div class="dropdown mt-3 mb-3">
                          <TextValidator
                            // id="search"
                            label="Search brand..."
                            name="search"
                            className={classes.textField}
                            // margin="normal"
                            variant="outlined"
                            value={insearchBrand}
                            type="text"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            inputProps={{ maxLength: 61 }}
                            // validators={["required", "maxStringLength:60"]}
                            // errorMessages={[
                            //   "Title is required",
                            //   "maximum character is 60",
                            // ]}
                            onChange={loadoptionBrand}
                            autoComplete="off"
                            // autoFocus
                          />

                          <div
                            className="dropdown-menu overflow-auto"
                            aria-labelledby="dropdownMenuButton"
                            style={{ width: "100%", height: "200px" }}
                          >
                            {/* <div className="position-relative bg-white opacity-100"> */}
                            {optionBrand.map((e) => {
                              return (
                                <div>
                                  <div
                                    class="dropdown-item"
                                    onClick={() => {
                                      setinsearchBrand(e.label);
                                      handleChangeSelectBrand(e);
                                      setopenSelectBrand(false);
                                      getProduct(e.value);
                                      setinsearch("");
                                    }}
                                  >
                                    <img
                                      src={e.logo}
                                      style={{
                                        width: "2rem",
                                        height: "2rem",
                                        marginRight: "1rem",
                                      }}
                                      alt=""
                                    />
                                    {e.label}
                                  </div>
                                </div>
                              );
                            })}
                            {/* </div> */}
                          </div>
                        </div>
                        {/* ) : null} */}
                        {/* </div> */}
                      </>
                    ) : null}
                    {/* END SEARCH BRAND */}
                    {/* SEARCH PRODUCT */}
                    {optionProduct && optionProduct.length > 0 ? (
                      <>
                        <div className="dropdown">
                          {/* <div class="input-group mb-3"> */}
                          <TextValidator
                            // id="search"
                            label="Search product..."
                            name="search"
                            className={classes.textField}
                            // margin="normal"
                            variant="outlined"
                            value={insearch}
                            type="text"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            inputProps={{ maxLength: 61 }}
                            // validators={["required", "maxStringLength:60"]}
                            // errorMessages={[
                            //   "Title is required",
                            //   "maximum character is 60",
                            // ]}
                            onChange={loadoption}
                            autoComplete="off"
                            // autoFocus
                          />

                          <>
                            <div
                              className="dropdown-menu overflow-auto"
                              aria-labelledby="dropdownMenuButton"
                              style={{ width: "100%", height: "200px" }}
                            >
                              {optionProduct.map((e) => {
                                return (
                                  <div
                                    class="dropdown-item"
                                    onClick={() => handleChangeSelect(e)}
                                  >
                                    <img
                                      src={e.logo}
                                      style={{
                                        width: "3rem",
                                        height: "3rem",
                                        marginRight: "1rem",
                                      }}
                                      alt=""
                                    />
                                    {e.label}
                                  </div>
                                );
                              })}
                            </div>
                          </>
                          {/* ) : null} */}
                        </div>
                      </>
                    ) : null}
                    {/* END SEARCH PRODUCT */}

                    <button
                      type="button"
                      onClick={() => {
                        setbuttonAddProduct(true);
                      }}
                      class="btn btn-danger btn-lg btn-block mt-3"
                    >
                      Cancel
                    </button>
                  </>
                )}
                <InputTextareaEditor
                  id="description"
                  name="description"
                  value={state.formData.description}
                  modules={modules}
                  formats={formats}
                  // style={{ height: "4rem" }}
                  // className="h-50"
                  // rows="10"
                  onChange={(e) => handleChange({ target: e })}
                  placeholder=" Add Description"
                  validators={["required"]}
                  errorMessages={["Description is required"]}
                  showToolBar={true}
                />
                <Grid container item xs={12} className={classes.dateMall}>
                  <Grid xs={4}>
                    {props.data == null ? (
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          id="date-picker-dialog-1"
                          format="dd/MM/yyyy"
                          value={startDate}
                          minDate={new Date()}
                          inputVariant="outlined"
                          label="Start Date"
                          views={["year", "month", "date"]}
                          onChange={handleDateChange}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    ) : (
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          id="date-picker-dialog-1"
                          format="dd/MM/yyyy"
                          value={startDate}
                          inputVariant="outlined"
                          label="Start Date"
                          views={["year", "month", "date"]}
                          onChange={handleDateChange}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    )}
                  </Grid>

                  <Grid container item xs={1}></Grid>

                  <Grid container item xs={4}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        id="date-picker-dialog-2"
                        format="dd/MM/yyyy"
                        inputVariant="outlined"
                        label="End Date"
                        value={endDate}
                        views={["year", "month", "date"]}
                        minDate={startDate}
                        onChange={handleDueDateChange}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                </Grid>
              </Grid>

              <TextValidator
                id="link_url"
                label="Add URL Banner"
                name="link_url"
                placeholder="https://example.com"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                value={state.formData.link_url}
                type="url"
                inputProps={{ maxLength: 61 }}
                // validators={["required", "maxStringLength:60"]}
                errorMessages={[
                  // "URL is required",
                  "maximum character is 60",
                ]}
                onChange={handleChange}
                autoFocus
              />

              <Grid item xs={12}>
                <Typography
                  variant="subtitle1"
                  className={classes.header}
                  gutterBottom
                  style={{ marginTop: "1rem" }}
                >
                  Image Editorial
                </Typography>
                <Grid container item xs={12}>
                  {state.formData["image_urls"].length > 0 ? (
                    // state.formData["image_urls"].map(
                    //   (imageUrl, keyImageUrl) => {
                    //     return (
                    //       <InputImage
                    //         key={imageUrl || keyImageUrl}
                    //         image={imageUrl || ""}
                    //         maxSize={100000}
                    //         aspectW={16}
                    //         aspectH={9}
                    //         removeType="delete"
                    //         onUploadDone={(url) => {
                    //           const { formData } = state;
                    //           let lastIndex = formData["image_urls"].length - 1;
                    //           formData["image_urls"][lastIndex] = url;
                    //           let image_urls = formData["image_urls"];
                    //           appActions.setImageUrls(image_urls);
                    //           formData["image_urls"].push("");
                    //           setState({
                    //             formData,
                    //           });
                    //         }}
                    //         onRemove={() => onRemoveImage(imageUrl)}
                    //       />
                    //     );
                    //   }
                    // )
                    <>
                      <InputImage
                        image={state.formData.image_urls[0] || ""}
                        maxSize={100000}
                        aspectW={16}
                        aspectH={9}
                        removeType="delete"
                        onUploadDone={(url) => {
                          const { formData } = state;
                          formData["image_urls"].push(url);
                          let image_urls = formData["image_urls"];
                          appActions.setImageUrls(image_urls);
                          formData["image_urls"].push("");
                          setState({ formData });
                        }}
                        onRemove={() =>
                          onRemoveImage(state.formData.image_urls[0])
                        }
                      />
                      <br />
                      <p
                        style={{
                          fontSize: 10,
                          color: "#757575",
                          lineHeight: 1,
                          marginLeft: "1rem",
                        }}
                      >
                        <br />
                        JPEG or 32-bit PNG
                        <br />
                        1280 px by 720 px
                        <br />
                        16:9
                        <br />
                        Up to 1 MB
                      </p>
                    </>
                  ) : (
                    <>
                      <h1></h1>
                      <InputImage
                        image=""
                        maxSize={100000}
                        aspectW={16}
                        aspectH={9}
                        removeType="delete"
                        onUploadDone={(url) => {
                          const { formData } = state;
                          formData["image_urls"].push(url);
                          let image_urls = formData["image_urls"];
                          appActions.setImageUrls(image_urls);
                          formData["image_urls"].push("");
                          setState({ formData });
                        }}
                        onRemove={(url) => onRemoveImage(url)}
                      />
                      <br />
                      <p
                        style={{
                          fontSize: 10,
                          color: "#757575",
                          lineHeight: 1,
                          marginLeft: "1rem",
                        }}
                      >
                        <br />
                        JPEG or 32-bit PNG
                        <br />
                        1280 px by 720 px
                        <br />
                        16:9
                        <br />
                        Up to 1 MB
                      </p>
                    </>
                  )}
                </Grid>
                {isHighlightTrigger ? (
                  <>
                    <div class="form-check " style={{ marginTop: "1rem" }}>
                      <input
                        class="form-check-input"
                        style={{
                          width: "1.2rem",
                          height: "1.2rem",
                        }}
                        name="isHighLight"
                        type="checkbox"
                        // value=""
                        checked={isHighLight}
                        onChange={handleChangeHighlight}
                        id="flexCheckDefault"
                      />
                      <label
                        style={{ marginLeft: ".7rem" }}
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Highlight
                      </label>
                    </div>
                  </>
                ) : null}
              </Grid>
            </Grid>
          </Paper>
        </ValidatorForm>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleCloseDialog();
          }}
          color="primary"
        >
          Cancel
        </Button>
        <Button
          type="submit"
          form="myform"
          variant="contained"
          style={{ marginRight: 30 }}
          color="primary"
          // onClick={handleSubmit(e)}
          // disabled={startDate === "" || endDate === ""}
        >
          Submit
        </Button>
      </DialogActions>
    </CustomizedDialogs>
  );
}

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function submitFormPromoMall(title, data, options = {}) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      title,
      data,
      ...options,
    }
  );
}
